import * as React from "react";

const SvgIcnDashboardBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M15.453 8.375a.525.525 0 01.297-.04c.104.017.193.06.266.134a.516.516 0 01.117.265.456.456 0 01-.055.297l-2.36 4.64a.348.348 0 01-.085.11.574.574 0 01-.117.078l-4.782 1.985a.24.24 0 01-.093.039.673.673 0 01-.11.008.43.43 0 01-.18-.04.5.5 0 01-.148-.101.458.458 0 01-.133-.258.504.504 0 01.04-.289l2.25-4.515a.452.452 0 01.203-.203l4.89-2.11zm-5.86 6.016l2.735-1.063-1.375-1.719-1.36 2.782zm3.548-1.641l1.375-2.828L11.75 11l1.39 1.75zM12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnDashboardBold;
